@if (!hideIcon) {
    <svg class="display-asset_icon">
        <use [attr.xlink:href]="displayAsset.assetIcon"></use>
    </svg>
}
<span>{{displayAsset.name}} </span>
@if (displayAsset.name !== displayAsset.symbol) {
    <span class="display-asset_symbol">{{displayAsset.symbol}}</span>
}
